import $ from 'jquery';
import './bootstrap';
import './slider';
// import './overflow_menu';
// import './video_player';
import './common';
// import './shuffle';
// import './slick';
import './custom';
// import 'owl.carousel';

$.ajaxSetup({
  headers: {
    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
  }
});

$(window).on('load', function() {
  $(document).ready(function() {
    $(window).scroll(function() {
      if ($(this).scrollTop() > 100) {
        $('#scroll-to-top-btn').fadeIn();
      } else {
        $('#scroll-to-top-btn').fadeOut();
      }

      var height = $('header').outerHeight();
      if ($(this).scrollTop() >= height) {
        $('.navbar-nav').addClass('has-logo');
        $('.nav-item-logo').fadeIn();
      } else {
        $('.nav-item-logo').fadeOut(400, function() {
          $('.navbar-nav').removeClass('has-logo');
        });
      }
    });
    $('#scroll-to-top-btn').click(function() {
      $("html, body").animate({scrollTop: 0}, 400);
      return false;
    });

    $('.cmd-mobile-application #dismiss, .cmd-mobile-application .overlay').on('click', function() {
      $('#sidebar-menu').removeClass('active');
      $('.overlay-sidebar').removeClass('active');
      $('body').toggleClass('opened-sidebar-menu');
    });

    $('.cmd-mobile-application #sidebarCollapse').on('click', function() {
      $('#sidebar-menu').addClass('active');
      $('.overlay-sidebar').addClass('active');
      $('.cmd-mobile-application .cls-siderbar-container .collapse.in').toggleClass('in');
      $('body').toggleClass('opened-sidebar-menu');
      $('.cmd-mobile-application .cls-siderbar-container a[aria-expanded=true]').attr('aria-expanded', 'false');
    });

    // // Load carousel
    // $('.owl-carousel.cmd-carousel').owlCarousel({
    //   autoWidth: true,
    //   dots: false,
    // });



  });

  var imgGalleries = $('.cmd-img-gallery');

  imgGalleries.each(function() {
    var $imgGallery = $(this);
    initImgGallery($imgGallery);
  });

  var trendings = $('.cmd-trending');

  trendings.each(function() {
    var $trending = $(this);
    initTrending($trending);
  });
})


function initImgGallery($imgGallery) {
  var $displaySlider = $('.cmd-img-gallery-display', $imgGallery);
  $displaySlider.slider();

  var $thumbSlider = $('.cmd-img-gallery-thumb', $imgGallery);
  $thumbSlider.slider();

  var displaySlider = $displaySlider.data('cmd.slider');
  var thumbSlider = $thumbSlider.data('cmd.slider');

  updateThumbSlider(thumbSlider, {offset: displaySlider.getOffset()});
  updateDisplaySlider(displaySlider, {offset: thumbSlider.getOffset()});
  updateSlideNumber(displaySlider, $imgGallery);

  $displaySlider.on('cmd.slided', function(data) {
    updateSlideNumber(displaySlider, $imgGallery);
    updateThumbSlider(thumbSlider, data);
  });

  thumbSlider.$items.each(function(i) {
    $(this).on('click', function() {
      updateDisplaySlider(displaySlider, {index: i});
    });
  });
}

function updateThumbSlider(thumbSlider, data) {
  var index = 0;

  if (data.offset) {
    index = Math.round(Math.abs(data.offset) / (data.amount * data.step));
  }

  var thumbOffset = Math.abs(thumbSlider.getOffset());
  var indexOffset = (thumbSlider.getTotalItemWidth() / thumbSlider.$items.length) * index;

  if (indexOffset < thumbOffset)
    thumbSlider.slideTo(-indexOffset);
  if (indexOffset >= thumbOffset + thumbSlider.$elementInner.width() - thumbSlider.$firstItem.outerWidth()) {
    thumbSlider.slideTo(-(indexOffset - thumbSlider.$elementInner.width() + thumbSlider.$firstItem.outerWidth()));
  }

  thumbSlider.$items.each(function(i) {
    if (i == index) {
      $('.cmd-figure', $(this)).css({
        'width': '108%',
        'margin-left': '-4%',
        'border': '4px solid yellow'
      });

    } else {
      $('.cmd-figure', $(this)).css({
        'width': '100%',
        'margin-left': '0',
        'border': 'none'
      });
    }
  });
}

function updateDisplaySlider(displaySlider, data) {
  displaySlider.slideTo(-(data.index * displaySlider.getTotalItemWidth() / displaySlider.$items.length));
}

function updateSlideNumber(displaySlider, $imgGallery) {
  var $slideNumber = $('.cmd-slide-number', $imgGallery);
  var offset = Math.abs(displaySlider.getOffset());
  var itemWidth = displaySlider.getTotalItemWidth() / displaySlider.$items.length;
  var slideNumber = Math.round(offset / itemWidth + 1);
  $slideNumber.text(slideNumber + '/' + displaySlider.$items.length);
}

function initTrending($trending) {
  var $slider = $('.cmd-trending-window', $trending);
  $slider.slider();

  var slider = $slider.data('cmd.slider');

  var index = Math.round(Math.abs(slider.getOffset()) / (slider.$firstItem.outerWidth()));
  var total = Math.ceil(slider.getTotalItemWidth() / slider.$elementInner.width());
  $('.cmd-slide-number', $trending).text((index + 1) + '/' + total);

  $slider.on('cmd.slided', function(data) {
    var index = Math.round(Math.abs(data.offset) / (data.amount * data.step));
    var total = Math.ceil(slider.getTotalItemWidth() / slider.$elementInner.width());
    $('.cmd-slide-number', $trending).text((index + 1) + '/' + total);
  });
}


// Load next post
$(document).ready(function() {
  let outerPanel = $('#id-cmd-next-posts-container');
  let didScroll = false;

  $(window).scroll(function() { //watches scroll of the window
    didScroll = true;

    var docViewTop = $(window).scrollTop();

    if (typeof loadPageElement !== "undefined") {
      clearTimeout($.data(this, 'scrollTimer'));
      $.data(this, 'scrollTimer', setTimeout(function() {
        // do something
        $.each(loadPageElement, function(index, item) {
          if (docViewTop >= item.from && docViewTop <= item.to) {
            const title = item.titleObject.text();
            if (title != null) {
              document.title = title;
            }
            // Update statge
            window.history.pushState(item.html, (title != null ? title : "Carmudi"), item.nextPostURL);
            return;
          }
        });
      }, 30));
    }
  });

  setInterval(function() {
    if (didScroll && typeof nextPostURLs !== 'undefined') {
      didScroll = false;
      if (($(document).height() - $(window).height()) - $(window).scrollTop() > 1000) {
        getNextPostURL();
      }
    }
  }, 100);

  // Get next url
  function getNextPostURL() {
    let loadRelated = false;
    let nextPostURL = (nextPostURLs[0]) ? nextPostURLs[0] : null;
    if (!nextPostURL) {
      return;
    } else {
      if (nextPostURLs.length === 1) {
        loadRelated = true;
      }
      getNextPostAndRender(nextPostURL, loadRelated);
      nextPostURLs.shift();
    }
  }

  // Load next post
  function getNextPostAndRender(nextPostURL, loadRelated = false) {
    if (typeof onShowMode === 'undefined' || onShowMode === null) {
      onShowMode = "";
    }
    const urlRequest = nextPostURL + onShowMode + '?loadRelated=' + loadRelated + '&loadMore=true';
    $.ajax({
      type: "GET",
      context: document.body,
      url: urlRequest,
      error: function() { //remove the loading message
        getNextPostURL();
      },
      success: function(html) { // success! YAY!! Add HTML to content container
        let divItem = $('<div class="cmd-post-item" style="display:none"></div>');
        outerPanel.append(divItem);
        divItem.html(html).fadeIn().delay(100);

        var adsLoadMore2 = $('.cms-ads-load-more-2');
        if (adsLoadMore2.length > 0) {
          divItem.find('.cmd-show-ads-load-more-2').html(adsLoadMore2.html());
        }

        var adsLoadMore3 = $('.cms-ads-load-more-3');
        if (adsLoadMore3.length > 0) {
          divItem.find('.cmd-show-ads-load-more-3').html(adsLoadMore3.html());
        }

        const title = null;
        const titleObject = divItem.find('.cmd-article-header .cmd-article-title');
        const elScroll = $(divItem);
        const elOffsetTop = elScroll.offset().top;
        loadPageElement.push({
          titleObject: titleObject,
          nextPostURL: nextPostURL + onShowMode,
          from: elOffsetTop,
          to: elOffsetTop + elScroll.outerHeight(),
          html: html
        });
      }
    });
  }

  function isScrolledIntoView(elem) {
    var docViewTop = $(window).scrollTop();
    var docViewBottom = docViewTop + $(window).height();

    var elemTop = $(elem).offset().top;
    var elemBottom = elemTop + $(elem).height();
    return (elemTop + 5) >= docViewTop;
  }

  // After load
  setPositionAdsFixed();

  // Submit form
  // this is the id of the form
  $("#campaign-form-submit").submit(function(e) {
    $('#btn-campaign-form-submit').attr('disabled', 'disabled');
    e.preventDefault(); // avoid to execute the actual submit of the form.

    var form = $(this);
    var url = form.attr('action');
    var name = $('.frm-message-name').val();
    var phone = $('.frm-message-phone').val();
    var location = $('.frm-message-location').val();
    
    if (!name) {
      return showErrorSubmitCaimpagin('Vui lòng nhật tên.');
    } else if (!phone) {
      return showErrorSubmitCaimpagin('Vui lòng nhập số điện thoại.');
    } else if(phone.length != 10 || !$.isNumeric(phone)) {
      return showErrorSubmitCaimpagin('Số điện thoại không hợp lệ.');
    } else {
      showErrorSubmitCaimpagin()
      $.ajax({
        type: "POST",
        url: url,
        data: {
          name: name,
          phone: phone,
          location: location
        },
        success: function(data)
        {
          $('#btn-campaign-form-submit').attr('disabled', false);
          $('.mc-message-show').hide();
          $('.mc-message-success').fadeIn(200);
        },
        error: function (request, status, error) {
          $('#btn-campaign-form-submit').attr('disabled', false);
          $('.mc-message-show').hide();
          $('.mc-message-error').fadeIn(200);
        }
      });
    }
    
    return false;
  });
});

$('.cmd-form-submit-caimpaign-input').on('blur keypress keyup', function() {
   var name = $('.frm-message-name').val();
   var phone = $('.frm-message-phone').val();
    
   if (!name) {
//      return showErrorSubmitCaimpagin('Vui lòng nhật tên.');
    } else if (!phone) {
//      return showErrorSubmitCaimpagin('Vui lòng nhập số điện thoại.');
    } else if(phone.length != 10 || !$.isNumeric(phone)) {
//      return showErrorSubmitCaimpagin('Số điện thoại không hợp lệ.');
    } else {
      return showErrorSubmitCaimpagin('', false);
    }
});

function showErrorSubmitCaimpagin(message = '', isShow = true) {
  if (isShow) {
    $('#btn-campaign-form-submit').attr('disabled', false);
    $('.mc-message-show').hide();
    $('.mc-message-error-invalid').html(message).fadeIn(200);
  } else {
    $('.mc-message-show').hide();
    $('.mc-message-error-invalid').html('').hide();
  }
}

function setPositionAdsFixed() {
  var containerOuter = $('.had-full-banner-ads');
  if (containerOuter.length > 0) {
    var outerWidth = $(window).width();
    var containerAdsObject = containerOuter.find('.cmd-content-ads-upper-outer');
    if (containerAdsObject.length > 0) {
      var containerAdsWidth = containerAdsObject.outerWidth();
      var widthPosition = (outerWidth - containerAdsWidth) / 2;
      $('.cmd-ads-fixed .cmd-block-embed-fixed').css({right: widthPosition + 'px'});
    }
  }

}

$(window).resize(function() {
  setPositionAdsFixed();
});


// WEBPACK FOOTER //
// ./resources/assets/js/app.js